import React from 'react';

const PPC2Layout = ({ children }) => {
  return (
    <div className="ppc2-layout">
      {children}
    </div>
  );
};

export default PPC2Layout;
